module.exports = __webpack_public_path__ + "img/env-handball.59322e2d.png";